module.exports = __webpack_public_path__ + "static/media/redesign.9ce0832e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/work/redesign.png
// module id = 397
// module chunks = 1